import { render, staticRenderFns } from "./MoreEventCard.vue?vue&type=template&id=7870f42a"
import script from "./MoreEventCard.vue?vue&type=script&lang=js"
export * from "./MoreEventCard.vue?vue&type=script&lang=js"
import style0 from "./MoreEventCard.vue?vue&type=style&index=0&id=7870f42a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports